import styles from "./ProductWhyChoose.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Product-template "Why choose" band (Figma `4669-6538` / mobile `5597-7546`):
 * eyebrow + heading + intro on navy, then title-only cards each led by a circular
 * featured icon.
 *
 * A SEPARATE component from `WhyChooseGrid` rather than a `dark` variant of it.
 * `WhyChooseGrid.module.scss` has only `.light` and `.grey` rules, so
 * `surface: "dark"` there would render the literal class `"undefined"` — the
 * Session-5 `PartnerBand.dark` trap. Adding the variant would edit a stylesheet
 * live on all 18 supplier pages; a separate stylesheet sharing zero selectors
 * means they cannot regress by construction.
 *
 * The card chrome mirrors `NetworkSection`/`CapabilityCards`' dark card values
 * (#08102A on #040919, 60px `rgba(255,255,255,.03)` circle + 8px `.06` ring, 32px
 * glyph) so the page's dark bands cannot drift apart visually.
 *
 * ⚠️ Icons must be light-on-dark: the coral registry glyphs (`industry`,
 * `compliance`, `drop`, …) are invisible on navy. Default is `blending` (white-60).
 */
export default function ProductWhyChoose({
  eyebrow,
  heading,
  subheading,
  items = [],
  columns = 2,
  markerIcon = "blending",
}) {
  if (!items.length) return null;
  const paras = Array.isArray(subheading)
    ? subheading
    : subheading
      ? [subheading]
      : [];

  return (
    <section className={styles.section}>
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {paras.map((p, i) => (
          <p className={styles.subheading} key={i}>
            {p}
          </p>
        ))}

        <div className={styles.grid} style={{ "--cols": columns }}>
          {items.map((item, i) => (
            <div className={styles.card} key={i}>
              <span className={styles.iconWrap}>
                <img
                  src={resolveIcon(item.icon || markerIcon)}
                  alt=""
                  aria-hidden="true"
                />
              </span>
              <p className={styles.title}>{item.title}</p>
              {item.desc && <p className={styles.desc}>{item.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
